import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/auth/auth';
import { SessionStorageService } from '@app/core/auth/session-storage';

/**
 * - path: '**' 用の形式上のコンポーネント（Router の NG04014 回避用）
 * - 通常は AuthGuardService.canMatch() が UrlTree を返す
 */
@Component({
  standalone: true,
  selector: 'app-fallback-redirect',
  template: '',
})
export class FallbackRedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
    private sessionService: SessionStorageService,
  ) {}

  ngOnInit(): void {
    const qIdToken = new URLSearchParams(window.location.search).get('idToken');
    const idToken = qIdToken ?? this.sessionService.getIdToken();
    if (!idToken) {
      this.router.navigate(['/', 'hospital'], { replaceUrl: true });
      return;
    }
    const target = this.authService.isAdminUser(idToken) ? 'admin' : 'hospital';
    this.router.navigate(['/', target], { replaceUrl: true });
  }
}
